import { MopedElectricOutlineIcon } from './MopedElectricOutlineIcon';

/**
 * author: Google
 * id FF5A5D35-99C8-475C-B672-362AF0FA9FC6
 * name moped-electric-outline
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/moped-electric-outline.svg
 * tags
 * - Transportation + Road 
 */
export const ScooterElectricOutlineIcon = MopedElectricOutlineIcon;
export default ScooterElectricOutlineIcon